import gql from 'graphql-tag'
export default gql`query typeOfWorksQuery {
  typeOfWorks {
    code
    description
    maxChloride
    minPercentageFine
    id
  }
}`